<template>
<div class="chapter">
<div class="inner_page">
<p class="crt2">Copyright © Lakshmi Raj Sharma</p>
<p class="crt">First American ebook edition published 2012 by Publerati, LLC.</p>
<p class="crt">Publerati e-ditions</p>
<p class="crt1">All rights reserved under International and Pan-American Copyright Conventions.</p>
<p class="crt1">This book is a work of fiction. Names, characters, businesses, organizations, places, events, and incidents are either the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events, or locales is entirely coincidental.</p>
<p class="crt1">Cover design by Tracey Tucker.</p>
<p class="crt1">Publerati ISBN 10: 0985050446</p>
<p class="crt">ISBN 13: 978-0-9850504-4-3</p>
<p class="crt1">Find other fine works of fiction at <a href="http://www.publerati.com" target="_blank">www.publerati.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7a24c4ef